<template>
  <div> 
    
    <printable-boxes :company="company" />

    <div class="row">
      <div class="col-6">
        <printable-status :company="company" />
      </div>
      <div class="col-6">
        <printable-months :company="company" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

import PrintableBoxes from '~/components/dashboard/PrintableBoxes.vue';
import PrintableStatus from '~/components/dashboard/PrintableStatus.vue';
import PrintableMonths from '~/components/dashboard/PrintableMonths.vue';

export default {
  middleware: 'auth',
  components: {
    'printable-status' : PrintableStatus,
    'printable-months' : PrintableMonths,
    'printable-boxes' : PrintableBoxes
  },
  computed: {
    company(){
      return this.$store.getters['auth/company'].id
    }
  },
  created(){

  },  
  data(){
    return {
    }
  },
  methods : {
  },
  metaInfo () {
    return { title: this.$t('home') }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue